import { MAX_ZOOM, MIN_ZOOM, useCamera } from "../player/camera";

/** Zoom, turn and recentre the map. Panning has no button: it is the drag. */
export function CameraTools() {
  const zoom = useCamera((c) => c.zoom);
  const angle = useCamera((c) => c.angle);
  const zoomBy = useCamera((c) => c.zoomBy);
  const turn = useCamera((c) => c.turn);
  const reset = useCamera((c) => c.reset);

  const home = zoom === 1 && angle === 0;

  return (
    <div className="pointer-events-auto flex flex-col-reverse items-end gap-1">
      <div className="flex items-center gap-1 rounded-lg border border-white/10 bg-black/60 p-1 backdrop-blur">
        <button
          title="Tourner de 45° à gauche"
          onClick={() => turn(-1)}
          className="grid h-7 w-7 place-items-center rounded text-sm transition hover:bg-white/10"
        >
          ↺
        </button>
        <button
          title="Tourner de 45° à droite"
          onClick={() => turn(1)}
          className="grid h-7 w-7 place-items-center rounded text-sm transition hover:bg-white/10"
        >
          ↻
        </button>

        <span className="mx-1 h-5 w-px bg-white/15" />

        <button
          title="Dézoomer"
          onClick={() => zoomBy(1 / 1.3)}
          disabled={zoom <= MIN_ZOOM}
          className="grid h-7 w-7 place-items-center rounded text-sm transition hover:bg-white/10 disabled:opacity-30"
        >
          −
        </button>
        <span className="w-10 text-center font-mono text-[11px] opacity-60">
          {zoom.toFixed(1)}×
        </span>
        <button
          title="Zoomer"
          onClick={() => zoomBy(1.3)}
          disabled={zoom >= MAX_ZOOM}
          className="grid h-7 w-7 place-items-center rounded text-sm transition hover:bg-white/10 disabled:opacity-30"
        >
          +
        </button>

        <span className="mx-1 h-5 w-px bg-white/15" />

        <button
          title="Revenir à la vue d'origine"
          onClick={reset}
          disabled={home}
          className="h-7 rounded px-2 text-[11px] transition hover:bg-white/10 disabled:opacity-30"
        >
          Recadrer
        </button>
      </div>
      {angle !== 0 && (
        <span className="rounded bg-black/60 px-2 py-0.5 font-mono text-[10px] opacity-60 backdrop-blur">
          {angle}°
        </span>
      )}
    </div>
  );
}
